
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const DigitalServicesPage = lazy(() => import('../pages/digital-services/page'));
const EventsPage = lazy(() => import('../pages/events/page'));
const ImportExportPage = lazy(() => import('../pages/import-export/page'));
const InvoicePage = lazy(() => import('../pages/invoice/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/digital-services',
    element: <DigitalServicesPage />,
  },
  {
    path: '/events',
    element: <EventsPage />,
  },
  {
    path: '/import-export',
    element: <ImportExportPage />,
  },
  {
    path: '/invoice',
    element: <InvoicePage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
